import { useMemo } from 'react';
import { collection, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { useFirestoreQuery } from './useFirestoreQuery';

/**
 * Company-scoped groups from `user_groups`.
 * @param {string | null | undefined} companyId
 */
export function useCompanyUserGroups(companyId) {
  const groupsQuery = useMemo(() => {
    if (!companyId) return null;
    return query(collection(db, 'user_groups'), where('companyId', '==', companyId));
  }, [companyId]);

  const { data, loading, error } = useFirestoreQuery(groupsQuery, {
    enabled: Boolean(companyId),
    silentPermissionDenied: true,
  });

  return {
    groups: data,
    loading,
    error,
  };
}
